<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-01-14                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-modal ref="loadingSpinnerModal"
           centered
           no-close-on-backdrop
           no-close-on-esc
           hide-footer
           header-bg-variant="primary"
           header-text-variant="light">
    <template #modal-header>
      <h5 class="modal-title">{{ message }}</h5>
    </template>
    <b-progress>
      <b-progress-bar :value="100" variant="primary" animated>
      </b-progress-bar>
    </b-progress>
  </b-modal>
</template>

<script>
export default {
  name: "yega1-loading-spinner",
  data() {
    return {
      spinnerStore:this.$store.state.LoadingSpinnerStore,
      is_shown:false,
      set_timeout_count:0
    }
  },
  props: {
    message: {
      type: String,
      default: 'Loading...'
    }
  },
  watch: {
    'spinnerStore.count': function(newCount, oldCount) {
      console.log(`spinnerStore.count. oldCount:${oldCount}, newCount:${newCount}`)
      if (oldCount === 0 && newCount > 0 && !this.is_shown) {
        console.log(`spinnerStore.count watch. oldCount:${oldCount}, newCount:${newCount}, is_shown:${this.is_shown}`)
        this.callShow();
      }
    }
  },
  computed:{
    spinner_ready_to_hide(){
      return this.spinnerStore.count === 0 || this.set_timeout_count>100;
    }
  },
  methods:{
    incrementSetTimeoutCount(){
      this.set_timeout_count = this.set_timeout_count +1;
    },
    resetSetTimeoutCount(){
      this.set_timeout_count = 0;
    },
    callShow(){
      this.is_shown = true;
      this.$refs.loadingSpinnerModal.show();
      this.callHide();
    },
    callHide(){
      if(this.spinner_ready_to_hide){
        console.log(`callHide, spinner ready to hide. Set time out count: ${this.set_timeout_count}, spinner store count:${this.spinnerStore.count}`)
        this.handleReadyToHide();
      }else{
        console.log(`callHide, spinner NOT ready to hide. Set time out count: ${this.set_timeout_count}, spinner store count:${this.spinnerStore.count}`)
        this.handleNotReadyToHide();
      }
    },
    handleReadyToHide(){
      this.is_shown = false;
      this.resetSetTimeoutCount();
      let that = this;
      setTimeout(()=>{
        that.$refs.loadingSpinnerModal.hide();
      },100);
    },
    handleNotReadyToHide(){
      this.incrementSetTimeoutCount();
      let that = this;
      setTimeout(()=>{
        that.callHide();
      },100)
    }
  }
}
</script>

<style scoped>

</style>
